import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { Paths, PATHS } from '../commons/paths';

export type MenuType = {
  key: string;
  title: string;
  path: Paths;
  subMenuList?: MenuType[];
  noIcon?: boolean;
  mobileOnly?: boolean;
};

export const ICON_SIZE = 'clamp(1rem, 0.583rem + 0.83vw, 1.25rem)'; // TODO: text-clamp_mと同じ
export const ICON_COLOR = 'var(--c-nav-color)';
export const SUB_ICON_COLOR = 'var(--c-nav-text)';
export const useMenuItems = (): MenuType[] => {
  const { t } = useTranslationWithLang('commons');

  return [
    {
      key: 'menu_1',
      title: t('TU000_002'),
      path: PATHS.RECRUITING_AUDITIONS,
    },
    {
      key: 'menu_2',
      title: t('TU000_004'),
      path: PATHS.NONE,
      subMenuList: [
        {
          key: 'menu_2_1',
          title: t('TU000_005'),
          path: PATHS.USER_EDIT,
        },
        {
          key: 'menu_2_2',
          title: t('TU000_006'),
          path: PATHS.USER_DELETE,
        },
      ],
    },
    {
      key: 'menu_3',
      title: t('TU000_003'),
      path: PATHS.CHANGE_PASSWORD,
    },
    {
      key: 'menu_5',
      title: t('TU000_007'),
      path: PATHS.FAQ,
    },
  ];
};
